import { ACTIONS } from '../Constants';

export const showModal = (showModalParams) => {
    const { modalType, modalProps } = showModalParams;

    return (dispatch) => {
        dispatch({
            type: ACTIONS.SHOW_MODAL,
            modalType,
            modalProps
        });
    };
};

export const hideModal = () => (dispatch) => {
    dispatch({
        type: ACTIONS.HIDE_MODAL
    });
};
